import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["discountAmount", "discountType", "discountAmountError"];

  toggleRedeemLimit(event) {
    const checkbox = event.target
    const container = document.getElementById('redeem_limit_input_container')
    
    if (container) {
      if (checkbox.checked) {
        container.style.display = 'block'
      } else {
        container.style.display = 'none'
        // Clear the input value when hiding
        const input = container.querySelector('input[type="number"]')
        if (input) {
          input.value = ''
        }
      }
    }
  }

  connect() {
    // Check initial state on page load
    const checkbox = document.getElementById('has_redeem_limit_checkbox')
    const container = document.getElementById('redeem_limit_input_container')
    
    if (checkbox && container) {
      if (checkbox.checked) {
        container.style.display = 'block'
      } else {
        container.style.display = 'none'
      }
    }

    // Validate on page load if there's already a value
    if (this.hasDiscountAmountTarget && this.hasDiscountTypeTarget) {
      this.validateDiscountAmount();
    }
  }

  validateDiscountAmount(event) {
    if (!this.hasDiscountAmountTarget || !this.hasDiscountTypeTarget || !this.hasDiscountAmountErrorTarget) {
      return true;
    }

    const amount = parseFloat(this.discountAmountTarget.value);
    const type = this.discountTypeTarget.value;

    // Clear previous error
    this.discountAmountErrorTarget.style.display = 'none';
    this.discountAmountErrorTarget.textContent = '';

    // Skip validation if field is empty (will be caught by required validation)
    if (!this.discountAmountTarget.value || this.discountAmountTarget.value.trim() === '') {
      return true;
    }

    // Validate percentage discounts
    if (type === 'Percent') {
      if (isNaN(amount) || amount <= 0) {
        this.showError('Discount amount must be greater than 0');
        return false;
      }
      if (amount > 99) {
        this.showError('Percentage discounts cannot exceed 99%');
        return false;
      }
    } else if (type === 'Value') {
      if (isNaN(amount) || amount <= 0) {
        this.showError('Discount amount must be greater than 0');
        return false;
      }
    }

    return true;
  }

  showError(message) {
    if (this.hasDiscountAmountErrorTarget) {
      this.discountAmountErrorTarget.textContent = message;
      this.discountAmountErrorTarget.style.display = 'block';
    }
  }

  validateBeforeSubmit(event) {
    if (!this.validateDiscountAmount()) {
      event.preventDefault();
      // Scroll to error message
      if (this.hasDiscountAmountErrorTarget) {
        this.discountAmountErrorTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
}

